import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, forkJoin, catchError, of } from 'rxjs';
import { StorageKey } from '../models/common';

/** Services */
import { StorageService } from './storage.service';

/** Environments */
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private storageSvc: StorageService,
    private router: Router,
    private http: HttpClient
  ) {

  }

  public login(returnUrl: string = ''): Observable<void> {

    return new Observable<void>((observer) => {

      let ctrlUrlLocal: string = "/auth/login";

      if (returnUrl) {
        ctrlUrlLocal += ("?returnUrl=" + returnUrl);
      }

      this.router.navigateByUrl(ctrlUrlLocal);

      observer.next(null);
      observer.complete();

    });

  }

  // public logout(): Observable<void> {

  //   return new Observable<void>((observer) => {

  //     forkJoin([this.storageSvc.remove(StorageKey.jwt), this.storageSvc.remove(StorageKey.refreshToken)]).subscribe(() => {

  //       localStorage.removeItem('selectedRoleId');

  //       this.router.navigateByUrl("/login");

  //       observer.next(null);
  //       observer.complete();

  //     });

  //   });

  // }

  public logout(): Observable<void> {
    return new Observable<void>((observer) => {
      this.clearStorageAndRedirect(observer);
    });
  }

  public logoutWithoutClearingStorage(): Observable<void> {
    return new Observable<void>((observer) => {
      // Just redirect to login without clearing storage
      this.router.navigateByUrl("/login");
      observer.next();
      observer.complete();
    });
  }

  private clearStorageAndRedirect(observer: any): void {
    forkJoin([
      this.storageSvc.remove(StorageKey.jwt),
      this.storageSvc.remove(StorageKey.refreshToken)
    ]).subscribe(() => {
      // Remove role & user-related context
      localStorage.removeItem('selectedRoleId');
      localStorage.removeItem('selectedCompanyId');
      sessionStorage.removeItem('USER');
      localStorage.clear();
      // sessionStorage.clear();

      // Redirect to login
      this.router.navigateByUrl("/login");

      observer.next();
      observer.complete();
    });
  }


  public isLoggedIn(): Observable<boolean> {

    return new Observable<boolean>((observer) => {

      this.storageSvc.getAsync(StorageKey.jwt).subscribe((x) => {

        let state: boolean = false;

        if (x) {

          state = true;

        }

        observer.next(state);
        observer.complete();

      });

    });

  }

}
